import { useState, useEffect, useRef } from 'react'
import { InputX, NoData, Button, SelectList, Layer } from 'components'
import useApp from 'hooks/useApp'
import Lib from 'library'
import useCommonCode from 'hooks/useCommonCode'
import styles from './index.module.css'
import { showFaqLayerState, showQuestionLayerState, searchDataState, pushDataState } from 'views/setting/states'
import { useRecoilState } from 'recoil'

const Faq = () => {

	const [showFaqLayer, setShowFaqLayer] = useRecoilState(showFaqLayerState)
	const [showQuestionLayer, setShowQuestionLayer] = useRecoilState(showQuestionLayerState)
	const [searchData, setSearchData] = useRecoilState(searchDataState)

	const App = useApp()
	const faqs = useCommonCode("FAQ_CLSFC");

	const [faqList, setFaqList] = useState([])
	const [tabs, setTabs] = useState([])
	const tab = useRef();
	const pushRef = useRef();
	const [showFilter, setShowFilter] = useState(false)
	const [showFaqList, setShowFaqList] = useState(false)
	const [faqSelectList, setFaqSelectList] = useState(false)
	const [selectFaqText, setSelectFaqText] = useState("전체")
	const [selectFaqCd, setSelectFaqCd] = useState(0)
	const [allFaqs, setAllFaqs] = useState()
	const [searchCount, setSearchCount] = useState()

	const [pushData, setPushData] = useRecoilState(pushDataState);    // 푸쉬 데이터
//	const [searchText, setSearchText] = useState()

	const openFilter = () => {
		setShowFaqList(true)
	}

	const closeFilter = () => {
		setShowFilter(false)
	}

	const getFaq = (code) => {
		return new Promise((resolve, reject) => {
			Lib.get(`/api/more/cstmr/srvc/faq`, { faqCd: code, pageNo: "1", pageSize: "10", rowsPerPage: "1000" }, data => {
				resolve(data)
			})
		})
	}

	const onClick = e => {
		const target = e.currentTarget || e.target
		const li = target.closest("li")
		const p = li.querySelector("p.padding")
		const h = p.getBoundingClientRect().height
		if (li.classList.contains("drop-active")) {
			li.querySelector(".drop-cont").style.height = ``
		} else {
			li.querySelector(".drop-cont").style.height = `${h}px`
		}
		li.classList.toggle("drop-active")
	}

	const showAll = () => {
		allFaqs.forEach(item => {
			item.hidden = false
		})
		setAllFaqs([...allFaqs])
	}

	const SetFaqList = () => {
		const data = [{
			key: "전체",
			value: 0
		}]
		faqs.forEach(item => {
			data.push({
				key: item.commNm,
				value: item.commCd
			})
		})
		setFaqSelectList(data)
	}

	/* const onSearchClick = e => {
		let value,faqCd
		if (typeof e === "object") {
			const target = e.currentTarget || e.target
			value = target.value
			faqCd = selectFaqCd
		} else if (typeof e === "string" || typeof e === "number") {
			faqCd = e
			value = searchText
		}
		//tab.current.setTab(0)
		let count = 0
		if (Lib.isNull(value)) value = ""		
		if (value === "" && faqCd === 0) {
			showAll()
		} else {
			console.log("func", value, faqCd)
			const newFaq = allFaqs.map(item => {
				const regexp = new RegExp(value, "gi")
				if ((regexp.test(item.faqConts) || regexp.test(item.faqTitle)) && (faqCd === 0 || faqCd === item.faqCd)) {
					item.hidden = false
					count++
					// item.faqConts = item.faqConts.replace(regexp, `<span style="color: orange">${value}</span>`)
					// item.faqTitle = item.faqTitle.replace(regexp, `<span style="color: orange">${value}</span>`)
				} else {
					item.hidden = true
				}
				return item
			})
			setAllFaqs([...newFaq])
		}
		// setFaqList(faqList)
		setSearchText(value)
	} */

	const getAllFaqs = () => {
		Lib.get("/api/more/cstmr/srvc/faq", data => {
			setAllFaqs(data.map(item => {
				item.hidden = false
				return item
			}))
		})
	}


	useEffect(() => {
		if (!allFaqs) return
		let count = 0
		if (searchData === "" && selectFaqCd === 0) {
			showAll()
			setSearchCount()
		} else {
			const newFaq = allFaqs.map(item => {
				const searchString = searchData.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&')
				const regexp = new RegExp(searchString, "gi")
				if ((regexp.test(item.faqConts) || regexp.test(item.faqTitle)) && (selectFaqCd === 0 || selectFaqCd === item.faqCd)) {
					item.hidden = false
					count++
				} else {
					item.hidden = true
				}
				return item
			})
			setAllFaqs([...newFaq])
			setSearchCount(count)
		}
	}, [searchData, selectFaqCd])

	useEffect(() => {
		if (faqs) {
			console.log("faqs 안에 까지는 옴");
			SetFaqList();
			// pushRef.current?.scrollIntoView({ behavior: 'smooth' });
			console.log("??");
			return
			if (faqs) {
				console.log(faqs)
				const newTabs = [{
					title: "전체",
					active: true
				}]
				const promiseList = []
				faqs.forEach(item => {
					const commNm = item.commNm
					newTabs.push({
						title: commNm
					})
					promiseList.push(getFaq(item.commCd))
				})
				Promise.all(promiseList).then(results => {
					console.log(results)
					const newFaqList = []
					results.forEach((list, index) => {
						const group = {
							faqCd: faqs[index].faqCd,
							faqCdNm: faqs[index].faqCdNm,
							data: list,
							count: list.length
						}
						newFaqList.push(group)
					})
					const newData = []
					newFaqList.forEach(item => {
						newData.push(...item.data)
					})
					setFaqList([
						{
							faqCd: "ALL",
							faqCdNm: "전체",
							data: newData,
							count: newData.length
						},
						...newFaqList
					])
				})
				//setTabs(newTabs)
	
	
				const data = [{
					key: "전체",
					value: 0
				}]
				faqs.map(item => {
					data.push({
						key: item.commNm,
						value: item.commCd
					})
				})
				setFaqSelectList(data)
			}
		}
	}, [faqs])

	useEffect(() => {
		console.log(faqList)
	}, [faqList])

	// useEffect(() => {
	// 	if (showFaqLayer) {
	// 		getAllFaqs()

	// 		setSelectFaqText("전체")
	// 		setSelectFaqCd(0)
	// 		setSearchData("")
	// 	}
	// }, [showFaqLayer])

	useEffect(() => {
		// PUSH DATA 처리
		if (showFaqLayer) {
			getAllFaqs()

			setSelectFaqText("전체")
			setSelectFaqCd(0)
			setSearchData("")

			if (pushData && pushData.url) {
				document.querySelector("nav .active")?.classList.remove("active");

				const urlArr = (pushData.url).split("/");
				if (urlArr[2] === "faq") {
					if (pushData.no === "") {
						// 상세조회가 아닌 경우,
						setPushData(null);
					}
				}
			}
		}
    }, [showFaqLayer])

	return (
		<Layer show={showFaqLayer} closeLayer={() => setShowFaqLayer(false)}>
			<div className="page">
				<div className="padding flex_1">
					<div className={styles.title}>FAQ</div>
					<div className="form-group search-bar mt_40">
						<InputX placeholder="궁금한 내용을 검색해보세요" value={searchData} onX={() => setSearchData("")} onChange={e => setSearchData(e.target.value)} />
						<i className="icon icon_search"></i>
					</div>

					<div className="filter-group justify_between mt_40">
					    {
					        searchCount > 0 ?
					            <div><strong>{searchData}</strong>에 대한 <span className="text-red">{searchCount}</span>개의 결과</div>
					            :
					            <div></div>
					    }
						<div onClick={openFilter}>
							<span>{selectFaqText}</span>
							<i className="icon icon_filter ml_5" />
						</div>
					</div>

					{/* 카테고리 탭 부분 - 필터 하단 레이어쪽으로 넣어야 됌 */}
					{/* <Tab tabs={tabs} type="small shadow" className="box--gray tab-line mb_10"> */}

					<div className="drop-tit">
						{
							(typeof searchCount !== "undefined" &&
								searchCount === 0)
								?
								<NoData text="검색된 FAQ가 없습니다." />
								:
								<ul className={`${styles["faq-list"]} accordion-list mt_10`}>
									{
										allFaqs &&
										(
											allFaqs.map((item, index) => {
												if (item.hidden === false) {
													return <List key={index} item={item} showFaqLayer={showFaqLayer} pushData={pushData} setPushData={setPushData} pushRef={pushRef} />
												}
												// <Nosearch searchText={searchText} />
											})
										)
									}
								</ul>

						}
					</div>
					{/* </Tab> */}
				</div >
				{searchData &&
					<div className="flex-shrink_0 padding">
						<span className="flex-justify_center mb_20" style={{ color: "#999" }}>원하는 내용을 찾지 못했나요?</span>
						<Button className="btn btn--big" onClick={() => setShowQuestionLayer(true)}>1:1 문의하기</Button>
					</div>
				}

				{/* <FilterLayer show={showFilter} closeLayer={closeFilter} /> */}

				<SelectList show={showFaqList} setShow={setShowFaqList} data={faqSelectList} selected={selectFaqCd} title="문의 유형" onSelect={(key, value) => {
					setSelectFaqText(key)
					setSelectFaqCd(value)
				}} />

			</div >
		</Layer>
	)
}



const List = ({ item, showFaqLayer, pushData, setPushData, pushRef }) => {
	//아이콘 눌렀을 때 답변내용 폴딩
	const onClick = e => {
		const target = e.currentTarget || e.target
		const li = target.closest("li")
		const menu = li.querySelector(`.${styles.menu}`)
		if (li.classList.contains("active")) {
			li.classList.remove("active")
			menu.removeAttribute("style")
		} else {
			li.classList.add("active")
			const div = menu.querySelector("div")
			const height = div.getBoundingClientRect().height
			menu.style.height = `${height}px`
		}
	}

	useEffect(() => {
		// PUSH DATA 처리
		if (pushData && pushData.url && showFaqLayer) {
			const urlArr = (pushData.url).split("/");
			if (urlArr[2] === "faq") {
				if (pushData.no !== "" && (item.sno == pushData.no)) {
					pushRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
					// 상세조회인 경우,
					const li = document.getElementById(pushData.no);
					const menu = li.querySelector(`.${styles.menu}`);
					li.classList.add("active");
					const div = menu.querySelector("div");
					const height = div.getBoundingClientRect().height;
					menu.style.height = `${height}px`;
					setPushData(null);
				}
			}
		}
	}, []);

	return (
		<li onClick={onClick} className="Lst" id={item.sno} ref={(pushData && pushData.no == item.sno) ? pushRef : null}>
		{/* <li onClick={onClick} className="Lst" ref={pushRef}>  */}
			<div className="drop-tit">
				<div className="list-tit" style={{ maxWidth: "90%" }}>
					<span className="tag tag-box tag-blue">{item.faqCdNm}</span>
					<p style={{ whiteSpace: "", overflow: "hidden", textOverflow: "ellipsis", paddingRight: "1rem" }}>{item.faqTitle}</p>
				</div>
				<i className="icon_arrow_sm bottom"></i>
			</div>
			<div className={styles.menu}>
				<div>
					{item.faqConts}
				</div>
			</div>
		</li>
	)
}

const Nosearch = ({ searchData }) => {
	return (
		<div className="page">
			<div className="center-cont">
				<i className="icon icon_no_data" />
				<p className="mt_20"><span>'{searchData}'</span> 에 대한 검색 결과가 없어요.<br />
					다른 검색어를 입력해주세요.</p>
			</div>
		</div>
	)
}

//카테고리 하단 필터 레이어
// const FilterLayer = ({ show, closeLayer }) => {


// 	//FAQ카테고리 필터 데이터
// 	const faqs = useCommonCode("FAQ_CLSFC")

// 	const onCodeClick = (e, item) => {
// 		console.log(e)
// 		console.log(item)
// 		const target = e.currentTarget || e.target
// 		const li = target.closest("li")
// 		li.classList.toggle("on")
// 		closeLayer(true)

// 	}

// 	return (
// 		<LayerBottom title="문의 유형" show={show} closeLayer={closeLayer}>
// 			{/* <ul className="select-list">
// 				{
// 					faqs &&
// 					faqs.map((item, index) => {
// 						return (

// 							<li
// 								key={index}
// 								onClick={e => onCodeClick(e, item)}
// 							>
// 								{item.commNm}
// 							</li>

// 						)
// 					})
// 				}
// 			</ul> */}
// 		</LayerBottom>
// 	)
// }

export default Faq
